module.exports = __webpack_public_path__ + "static/media/Mobile-Inflatables-2.abf52e72.jpg";